import img1 from '/static/img/experience/traffic/chartereSwiper/img1.png'
import img2 from '/static/img/experience/traffic/chartereSwiper/img2.png'
const charterSwiperList = [
    {
        id:1,
        img:img1,
        list:[
            {
                id: 1,
                content: 'More than 50 business jets are available, covering top international models for a wide range of travel needs',
            },
            {
                id: 2,
                content: 'Covering international mainstream routes and more niche locations',
            },
            {
                id: 3,
                content: 'Cabin services can be customized',
            }
        ]
    },
    {
        id:2,
        img:img2,
        list:[
            {
                id: 1,
                content: 'More than 50 business jets are available, covering top international models for a wide range of travel needs44',
            },
            {
                id: 2,
                content: 'Covering international mainstream routes and more niche locations33',
            },
            {
                id: 3,
                content: 'Cabin services can be customized111',
            }
        ]
    },
]

export default {
    charterSwiperList
};